module.exports = {"pathContext":{"name":"ConditionalInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"operator","type":{"kind":"ENUM","name":"ConditionalOperator","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"quantity","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-conditional-input.json
// module id = 1390
// module chunks = 95314831745349